module.exports = __webpack_public_path__ + "media/images/logo/niet_gebruikt/zorg_id-23d779acfa2fdbb04b7fad8e58da397d.png";